<template>
    <nuxt-loading-indicator color="#FEA138" :height="3"></nuxt-loading-indicator>
    <header-component></header-component>

    <NuxtPage/>

    <client-only>
        <lazy-cart-bottom-cart></lazy-cart-bottom-cart>
    </client-only>

    <footer-component></footer-component>

</template>

<script setup>

import HeaderComponent from '~/components/header/index.vue'
import FooterComponent from '~/components/footer/index.vue'
import { useCartStore } from '~/store/cartStore';

const cartStore = useCartStore();

</script>